<template>
  <div>
    <el-dialog
      :title="$l('label_file_upload_title') || '文档上传'"
      :visible.sync="dialogVisible"
      :before-close="close"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="900px"
    >
      <el-form ref="form" :model="formData" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('label_file_type') || '文档类型'"
              prop="prjFileType"
            >
              <el-select
                size="small"
                v-model="formData.prjFileType"
                :placeholder="$l('tips_select_file_type') || '请选择文档类型'"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in dictOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('label_file_isPublic') || '文档权限'">
              <el-radio-group v-model="formData.isPublic" class="mt-1">
                <el-radio label="Y">{{
                  $l('label_file_isPublic_Y') || '相关项目公开'
                }}</el-radio>
                <el-radio label="N">{{
                  $l('label_file_isPublic_N') || '仅限本项目'
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          :label="$l('label_file_desc') || '文档说明'"
          prop="prjFileDesc"
        >
          <dict-select
            v-model="formData.atPersonCode"
            url="/digitalCenter/common/dict/baseUser"
            :placeholder="$l('tips_select_at') || '选择提醒谁看'"
            size="small"
            style="width: 100%"
            filterable
            :multiple="true"
            clearable
            :options="{ label: 'label', value: 'code' }"
          ></dict-select>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 10 }"
            v-model="formData.prjFileDesc"
            maxlength="200"
            style="width: 100%"
            clearable
            :placeholder="$l('tips_input_file_desc') || '请填写文档说明'"
          ></el-input>
        </el-form-item>
        <el-form-item required>
          <el-upload
            drag
            action="/oss/ossUploadReturnUrlAndFileId"
            show-file-list
            multiple
            :auto-upload="false"
            :on-change="onFileChange"
            :on-remove="onFileChange"
            style="width: 100%"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button size="small" @click="() => close()">
          {{ $l('btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          :loading="saveLoading"
          @click="save"
        >
          {{ $l('btn_save') || 保存 }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
export default {
  props: {
    params: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      dialogVisible: false,
      sampleTypeVisible: false,
      formData: {
        prjFileType: '',
        prjFileDesc: '',
        prjCode: '',
        prjFileCode: '',
        prjFileUrl: '',
        isPublic: 'Y',
        atPersonCode: [],
      },
      dictOption: [],
      rules: {
        prjFileType: [
          {
            required: true,
            message: this.$l('tips_select_file_type') || '请选择文档类型',
            trigger: 'change',
          },
        ],
        prjFileDesc: [
          {
            required: true,
            message: this.$l('tips_input_file_desc') || '请填写文档说明',
            trigger: 'blur',
          },
        ],
      },
      localFiles: [],
      saveLoading: false,
    }
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    load() {
      this.formData = {
        prjFileType: '',
        prjFileDesc: '',
        prjCode: '',
        prjFileCode: '',
        prjFileUrl: '',
        isPublic: 'Y',
        atPersonCode: [],
      }
      this.dialogVisible = true
      this.loadSelect()
    },
    // 获取供应商类别下拉
    loadSelect() {
      this.$api
        .systemDict({ dictType: 'prjFileType' })
        .then((res) => {
          this.dictOption = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async save() {
      // 验证表单
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.saveLoading = true

      if (this.params.prjCode) {
        this.formData.prjCode = this.params.prjCode
      }

      // 执行多附件上传任务 获取文件编码数组
      const prjFileCodes = await this.uploadTask().catch(
        () => (this.saveLoading = false)
      )
      this.formData.prjFileCodes = prjFileCodes
      if (!this.formData.prjFileCodes || !this.formData.prjFileCodes.length) {
        this.saveLoading = false
        this.$message({
          message: this.$l('tips_upload_file') || '请选择需要上传的文件',
          type: 'warning',
        })
        return false
      }

      this.$api
        .infoDocSaveApi(this.formData)
        .then(() => {
          this.saveLoading = false
          this.$message({
            showClose: true,
            message: this.$l('tips_save_ok') || '保存成功',
            type: 'success',
          })
          this.close()
          // 通知父组件保存成功
          this.$emit('success')
        })
        .catch(() => (this.saveLoading = false))
    },
    close() {
      this.formData.prjFileCode = ''
      this.formData.prjFileUrl = ''
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.dialogVisible = false
    },
    reset() {
      this.formData.prjFileCode = ''
      this.formData.prjFileUrl = ''
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    /**
     * 多附件上传任务
     */
    uploadTask() {
      const tasks = this.localFiles.map(
        (file) =>
          new Promise((resolve, reject) => {
            this.push({
              file: file.raw,
              added: ({ md5, suffix }) => {
                let code = md5 + '.' + suffix
                resolve(code)
              },
              fail: ({ message }) => {
                reject(message)
              },
            })
          })
      )

      return Promise.all(tasks).then((res) => {
        return res
      })
    },
    onFileChange(file, fileList) {
      this.localFiles = fileList
    },
  },
}
</script>
